import Icon from '../../components/Icon.vue'

Icon.register({"brands/playstation":{"width":576,"height":512,"paths":[{"d":"M570.9 372.3C559.6 386.5 532.1 396.6 532.1 396.6L327 470.2V415.9L477.9 362.1C495 356 497.7 347.3 483.7 342.7 469.8 338.1 444.6 339.4 427.5 345.6L327 381.1V324.7C350.2 316.9 374.1 311.1 402.7 307.9 443.6 303.4 493.6 308.5 532.9 323.4 577.1 337.4 582.1 358.1 570.9 372.3zM346.5 279.8V140.8C346.5 124.5 343.5 109.5 328.2 105.2 316.5 101.4 309.2 112.3 309.2 128.6V476.5L215.4 446.7V32C255.3 39.4 313.4 56.9 344.6 67.4 424.1 94.7 451 128.7 451 205.2 451 279.7 405 308 346.5 279.8zM43.2 410.2C-2.2 397.4-9.8 370.7 10.9 355.4 30 341.2 62.6 330.5 62.6 330.5L197.1 282.7V337.2L100.3 371.8C83.2 377.9 80.6 386.6 94.5 391.2 108.4 395.8 133.6 394.5 150.7 388.3L197.1 371.4V420.2C145.5 429.5 95.7 427.5 43.2 410.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/playstation.js
// module id = 66BD
// module chunks = 0